// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__-jNHb","loader":"style_loader__377QD","fullScreen":"style_fullScreen__3t7YC","hidden":"style_hidden__3NO9o"};